module.exports = __webpack_public_path__ + "static/cashnow-a39a2e0a3ba2d84bdd5cda78a2bf0331.jpg";